// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1SDBv","footer":"ModalInfo_footer__1YMQK"};